export default function () {
  this.loadTestimonials()
}
